(ns manage.content-configuration-page.placeholder-expression.singular
  (:require ["@mui/material/Stack$default" :as Stack]
            [clojure.string :as str]
            [common.ui.store :as store]
            [common.widgets.asset-upload :as upload]
            [manage.content-configuration-page.placeholder-expression.db
             :refer [pull-pattern-placeholder-expression value->singular-placeholder-expression value-string]]
            [manage.content-configuration-page.placeholder-expression.macro-input
             :refer [macro-input]]
            [manage.content-configuration-page.view.input :as view.input]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$]]))

(def macro-input-save-on-blur
  "Renders a macro input (react-slate).
   Tries to save current value on blur event."
  (view.input/with-value-props
    (fn [{:value-props/keys [update-value value save-value!]
          :keys [control-props]}]
      ($ macro-input (merge
                      {:multi-line? true
                       :read-only? (:disabled control-props)
                       :allow-macros? true}
                      control-props
                      {:value @value
                       :on-change update-value
                       :on-blur save-value!})))))

(defn with-placeholder-expression-view-input-props
  "Higher order component.
   Assoc view-input props into `view-fn` props (first arity)."
  [view-fn]
  (fn [props placeholder phe & args]
    (r/with-let [value (r/atom @(rf/subscribe [:singular-placeholder-expression/value-string phe]))
                 phe-default-value? (= (get-in placeholder [:placeholder/default-value :db/id])
                                       (:eid phe))]
      (let [sphe @(store/entity phe pull-pattern-placeholder-expression)
            props
            (assoc props
                   :view-input-props
                   {:entity/ref phe
                    :validation/schema :singular-placeholder-expression
                    :subscription [:singular-placeholder-expression/value-string phe]
                    :on-save [:manage.content-configuration-page.placeholder-expression.db/update-singular
                              (:eid phe)]
                    :on-change (partial reset! value)
                    :validation-value-fn (fn [entered-str-value]
                                           (merge sphe (value->singular-placeholder-expression nil entered-str-value)))
                    :control-props (cond-> props
                                     (:disabled? props)
                                     (assoc :read-only? true)

                                     (not phe-default-value?)
                                     (assoc :placeholder (value-string (:placeholder/default-value placeholder))))}

                   :value value)]

        (into [view-fn] (conj args phe placeholder props))))))

(defn with-editable-upload
  "Higher order component.
   When props :disabled? is falsy; render upload component
   When props :disabled? is truthy; render `disabled-view-fn`"
  [media-type file-extensions disabled-view-fn]
  (with-placeholder-expression-view-input-props
    (fn [{:keys [view-input-props value disabled?] :as props} placeholder phe & args]
      [:> Stack {:spacing 0.5}
       [macro-input-save-on-blur view-input-props]
       (if disabled?
         (when-not @(store/get-value phe :singular-placeholder-expression/macro)
           (into [disabled-view-fn] (conj args phe placeholder props)))
         ($ upload/upload {:resumable? true
                           :allow-macro? false
                           :onChange #(rf/dispatch (-> (:on-save view-input-props)
                                                       vec (conj %)))
                           :value @value
                           :path [:placeholder-expression-upload (:eid phe)]
                           :extensions (str/join ", " (map (partial str ".") file-extensions))
                           :filetype (name media-type)}))])))

(def text
  (with-placeholder-expression-view-input-props
    (fn [{:keys [view-input-props]}]
      [macro-input-save-on-blur view-input-props])))

(def audio
  (with-editable-upload :audio ["mp3"]
    (fn [{:keys [value]}]
      [:audio {:class :image-preview__audio
               :controls true
               :src @value}])))

(def image
  (with-editable-upload :image ["jpg" "png" "gif" "svg"]
    (fn [{:keys [value]}]
      [:img.image-preview__img {:src @value}])))

(def video
  (with-editable-upload :video ["mp4" "mov"]
    (fn [{:keys [value]}]
      [:video {:class "image-preview__video"
               :controls true
               :src @value}])))
